import HeadingPart from "../../Helper/HeadingPart";
import MoreArrow from "../../Helper/MoreArrow";

// assets
import mainImage from "../../../assets/svg/Image3.svg";

// constants
import headingPart from "../../../constants/headingPart";
import home from "../../../constants/home.js";
import moreArrow from "../../../constants/moreArrow";

const styles = {
  mainWrapper: "grid grid-cols-1 lg:grid-cols-2 sm:w-full",
  leftWrapper: "flex justify-start items-center",
  imgStyle: "h-full w-full sm:h-5/6",
  rightWrapper: "flex justify-center items-start md:items-center lg:items-start flex-col text-[#333333]",
  rightContainer: "flex flex-col justify-center items-start sm:items-center 2xl:text-lg",
  textContainer: "sm:w-11/12  flex items-center sm:centerContent text-sm sm:text-md",
};

const index = () => {
  return (
    <div className="w-full">
      <HeadingPart
        heading={headingPart.HEADING_WHO_WE_ARE}
        text={headingPart.TEXT_WHO_WE_ARE}
        order_1={2}
      />
      <div className={styles.mainWrapper}>
        {/* Left Side */}
        <div className={styles.leftWrapper}>
          <div className="mt-6">
            <img src={mainImage} alt="Who we are" className={styles.imgStyle} />
          </div>
        </div>

        {/* Right Side */}
        <div className={styles.rightWrapper}>
          <div className={styles.rightContainer}>
            <div className={styles.textContainer}>
              <p className="mt-2">
                <span className="font-bold">Blend</span>
                {home.WHO_WE_ARE_TEXT1}
              </p>
            </div>
            <div className={styles.textContainer}>
              <p className="mt-3">{home.WHO_WE_ARE_TEXT2}</p>
            </div>
            <div className={styles.textContainer}>
              <MoreArrow text={moreArrow.TEXT_TALK} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default index;
